import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
function Panel(props) {
  return <div className="ndx-Panel">{props.children}</div>;
}

Panel.displayName = 'Panel';

const propTypes = {
  children: PropTypes.any
};

Panel.propTypes = propTypes;

export default Panel;
